import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";
import { handleApiError } from "../config/errorHandler";

/**
 * Agent Logout API Call
 * @returns {Promise<Object>} - Response data from the API
 */
export const logoutAgentApi = async () => {
  try {
    const response = await apiClient.post(API_ENDPOINTS.LOGOUT);
    return response.data; // Return the response data
  } catch (error) {
    handleApiError(error); // Handle error with the common handler
    throw error; // Propagate the error
  }
};
